export default "/images/vendor/flag-icon-css/flags/1x1/cw.svg?3fc4503762b62953af04fb0bccc1436c";